(window as any).surveylab_chart_charts = undefined;